<template>
    <div>
        <BlacklistHeader view-type="exact"/>

        <div class="topbar pl-sm-5">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header class="topbar__key__header form-control-wrapper flex-wrap pl-0">
                        <input
                            v-model="newClient"
                            class="form-control form-control--big w-100 w-sm-auto mv-50 mr-sm-3 mb-3 mb-sm-0"
                            @keyup.enter="addClient"
                        />
                        <button class="button w-100 w-sm-auto" @click="addClient">Add client</button>
                    </header>
                </div>
            </div>
        </div>

        <div class="main-table-wrapper overflow-auto">
            <div class="main-table">
                <Grid
                    :columns="columns"
                    :data="items"
                    :has-filters="true"
                    :page-length="parseInt(pageLength)"
                    :total-rows-count="totalRowsCount"
                    :sort="sort"
                    :currentPage="currentPage"
                    @changePage="changePage"
                    @changeFilters="changeFilters"
                    @action="gridAction"
                />

                <template v-if="totalRowsCount">
                    <div class="main-inner">
                        <p>Total number of clients: {{totalRowsCount}}</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import Grid from "../../../../frontend/src/components/Grid"
import grid from "../../../../frontend/src/mixins/grid"
import blacklistedClientsService from "@/services/blacklisted-clients.service"
import BlacklistHeader from "@/components/clients/BlacklistHeader.vue";

export default {
    components: {
        BlacklistHeader,
        Grid,
    },

    mixins: [grid],

    data() {
        return {
            newClient: "",

            columns: [
                {
                    label: 'Client',
                    name: 'client',
                    filter: 'text',
                },
                {
                    name: 'actions',
                    label: 'Actions',
                    component: 'Actions',
                }
            ],

            getListMethod: blacklistedClientsService.getClients,
            errors: {},
        }
    },

    mounted() {
        this.getList()
    },

    methods: {
        gridAction(params) {
            if (params.action === 'delete') {
                this.deleteClient(params.rowId)
            }
        },

        deleteClient(id) {
            if (confirm("Delete client?")) {
                blacklistedClientsService.delete(id).then(() => {
                    this.getList()
                })
            }
        },

        async addClient() {
            if (this.newClient.length) {
                const {data} = await blacklistedClientsService.save(0, {client: this.newClient});
                this.errors = data.errors;

                if (Object.keys(this.errors).length) {
                    alert(Object.values(this.errors).flat().join('\n'));
                } else {
                    this.newClient = ""
                    this.getList()
                }
            }
        },
    }
}
</script>

<style scoped>

</style>
